export const environment = {
  apiUrl: 'https://seaca-api.unipin.dev/v1'
};
